module.exports = __webpack_public_path__ + "img/banner_detail_3.5dc1ad1a.png";